const defaults = {
  cartModal: '.js-ajax-cart-modal', // classname
  cartModalContent: '.js-ajax-cart-modal-content', // classname
  cartModalClose: '.js-ajax-cart-modal-close', // classname
  cartDrawer: '.js-ajax-cart-drawer', // classname
  cartDrawerContent: '.js-ajax-cart-drawer-content', // classname
  cartDrawerClose: '.js-ajax-cart-drawer-close', // classname
  cartDrawerTrigger: '.js-ajax-cart-drawer-trigger', // classname
  cartOverlay: '.js-ajax-cart-overlay', // classname
  cartCounter: '.js-ajax-cart-counter', // classname
  addToCart: '.js-ajax-add-to-cart', // classname
  removeFromCart: '.js-ajax-remove-from-cart', //classname
  removeFromCartNoDot: 'js-ajax-remove-from-cart', //classname,
  checkoutButton: '.js-ajax-checkout-button',
};

const cartModal = document.querySelector(defaults.cartModal);
const cartModalContent = document.querySelector(defaults.cartModalContent);
const cartModalClose = document.querySelector(defaults.cartModalClose);
const cartDrawer = document.querySelector(defaults.cartDrawer);
const cartDrawerContent = document.querySelector(defaults.cartDrawerContent);
const cartDrawerClose = document.querySelector(defaults.cartDrawerClose);
const cartDrawerTrigger = document.querySelector(defaults.cartDrawerTrigger);
const cartOverlay = document.querySelector(defaults.cartOverlay);
const cartCounter = document.querySelector(defaults.cartCounter);
const ajaxAddToCart = document.querySelectorAll(defaults.addToCart);
let removeFromCart = document.querySelectorAll(defaults.removeFromCart);
const checkoutButton = document.querySelector(defaults.checkoutButton);
const htmlSelector = document.documentElement;

for (let i = 0; i < ajaxAddToCart.length; i++) {

  ajaxAddToCart[i].addEventListener('click', function (event) {

    event.preventDefault();
    //const formID = this.parentNode.getAttribute('id');
    const formID = $(this).parents('.variants').attr('id');
    addProductToCart(formID);

    openCartDrawer();
    openCartOverlay();

  });
}


function addProductToCart(formID) {
   let formData = $(`#${formID}`).serialize();
   $.ajax({
      url: '/cart/add.js',
      data: formData,
      dataType: 'json',
      method: 'post',
      success: addToCartOk,
      error: addToCartFail,
    })
}

function fetchCart() {
  $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function (cart) {
      onCartUpdate(cart);
      if (cart.item_count === 0) {
        cartDrawerContent.innerHTML = 'Cart is empty';  
        console.log("Cart Is Empty?")
        $('.free_shipping_box').hide();
        $('.Cart_ShippingNotice .Drawer__Data').html('<p>Spend <span>$250.00</span> more to receive a 3% Discount</p>');

      } else {
        renderCart(cart);
        $('.free_shipping_box').show();
      }

    },
  });
}

function changeItem(line, callback) {
  const quantity = 0;
  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    success: function (cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      } else {
        onCartUpdate(cart);
        fetchCart();
        removeProductFromCart();
        renderCart(cart);
      }
    },
  });
}

// Cart Note Upadte Start
$('[data-cart-notes-textarea]').on('input', function (event) {
  var giftNoteMassage = $(this).val();
  event.preventDefault();
  if (giftNoteMassage.length > 0) {
    updateGiftNotes(giftNoteMassage)
  } 
  else{
    updateGiftNotes(giftNoteMassage)
  } 
});

function updateGiftNotes(note) {
  $.ajax({
    url: '/cart/update.js',
    method: 'POST',
    data: {note: note},
    success: function(result) { 
      return result;
    }
   }); 
}

// Cart Note Upadte End

function onCartUpdate(cart) {
  $('.cartCount').text(cart.item_count);
  $('.cartCountSelector').text(cart.item_count);
}

function addToCartOk(product) {
  console.log(product);
  cartModalContent.innerHTML = product.title + ' was added to the cart!';
  openCartOverlay();
  fetchCart();
}

function removeProductFromCart() {
  //     cartCounter.innerHTML = Number(cartCounter.innerHTML) - 1;
}

function addToCartFail() {
  cartModalContent.innerHTML = 'The product you are trying to add is out of stock.';
  openCartOverlay();
}

function renderCart(cart) {  
  var cart_total_header = Shopify.formatMoney(cart.items_subtotal_price);
  var cart_item_count = cart.item_count;
  $('.cart-title-price-main').text('(' + cart_item_count + ' Item' + (cart_item_count !== 1 ? 's' : '') + ')');
  $('.data-subtotal').text(Shopify.formatMoney(cart.total_price));
  $('.data-subtotal_price').text(Shopify.formatMoney(cart.items_subtotal_price));
  $('.data-subtotal_header').text('YOUR CART: ' + cart_total_header);
  $('.cartTotalSelector').text(Shopify.formatMoney(cart.total_price));
  if (cart.item_count > 0) {
    $('.main_subtotal').show();
    $('.ajax-cart-drawer__content').removeClass('Cart__Empty');
    $('.free_shipping_box .wrapper-cartCount ').show();
  }
  else {
    $('.main_subtotal').hide();
    $('.ajax-cart-drawer__content').addClass('Cart__Empty');
    $('.free_shipping_box .wrapper-cartCount ').hide();    
  }

  clearCartDrawer();

  cart.items.forEach(function (item, index) {
     var custom_length = '';
      if (item.options_with_values) {
        item.options_with_values.forEach(function (option, optionIndex) {
            var optionName = option.name || 'Untitled Name'; 
            var optionValue = option.value || 'Untitled Value'; 
            if (!['Engraving', 'URL', 'cost_price', 'vid', 'pid', 'variant_price', 'qty'].includes(optionName)) {
              custom_length += `${optionName}: <span class="custom_option_number">${optionValue}</span><br>`;
            }
        });
      }

    const aspectRatio = item.image.aspect_ratio;
    const calculatedHeight = Math.ceil(150 / aspectRatio);
    const productTitle = '<div class="ajax-cart-item__title">' + item.title + '</div>';
    const productImage = '<img class="ajax-cart-item__image" src="' + item.image + '" width="' + calculatedHeight + '" height="' + calculatedHeight + '" loading="lazy">';
    const productPrice = '<div class="ajax-cart-item__price">' + Shopify.formatMoney(item.line_price) + '</div>';
    //const productQuantity = '<div class="ajax-cart-item__quantity">' + item.quantity + '</div>';
    const productRemove = '<div class="ajax-cart-item__remove ' + defaults.removeFromCartNoDot + '"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><g opacity="0.6"><path d="M5.83366 3.33333V1.66666H14.167V3.33333H18.3337V5H16.667V17.5C16.667 17.9602 16.2939 18.3333 15.8337 18.3333H4.16699C3.70676 18.3333 3.33366 17.9602 3.33366 17.5V5H1.66699V3.33333H5.83366ZM5.00033 5V16.6667H15.0003V5H5.00033ZM7.50033 7.5H9.16699V14.1667H7.50033V7.5ZM10.8337 7.5H12.5003V14.1667H10.8337V7.5Z" fill="white"/></g></svg></div>';
    const MiniCartQty = '<div class="mini_qtybox"><span class="mini_btnqty qtyminus icon icon-minus" data-cartproductid="'+item.properties['pid']+'">-</span><input type="text" id="quantity" name="quantity" min="1" mavalue="' + item.quantity + '" class="quantity-selector quantity-input"><input type="hidden" value="' + item.variant_id + '" class="mini_cart_variant_id"><input type="hidden" value="' + item.quantity + '" class="mini_cart_product_qty"><span class="mini_btnqty qtyplus icon icon-plus" data-cartproductid="'+item.properties['pid']+'">+</span></div>';
    const productitemprice = item.price * item.quantity;
    const ProductTotalPrice = cart.original_total_price;
    let properties = '';

    /*HC*/
    let ORIGINAL_URL_PRODUCT = "";

    if (item.properties && Object.keys(item.properties).length > 0) {
      properties = '<ul class="CartItem__Properties">'
      Object.keys(item.properties).forEach(key => {   
        if (!(key === 'engraving' || key === 'url' || key === 'cost_price' || key === 'vid' || key === 'pid' || key === 'variant_price' || key === 'qty')) {        
        const isQty = key.toLowerCase() === 'qty'; 
        const displayKey = isQty ? 'Pieces' : key;
        if (key.toLowerCase() === 'engraving') {
        properties += `
          <li class="CartItem__Property ${isQty ? 'Qtyproperties' : ''}">
            <span class="CartItem__Property--key">Engraving Text: </span>
            <span class="CartItem__Property--value" style="opacity: 0.6;">${item.properties[key]}</span>
          </li>
        `;
        } else {
          /*HC*/
          if(displayKey != "_original_handle") {
            properties += `
            <li class="CartItem__Property ${isQty ? 'Qtyproperties' : ''}">
              <span class="CartItem__Property--key">${displayKey}: </span>
              <span class="CartItem__Property--value" style="opacity: 0.6;">${item.properties[key]}</span>
            </li>
          `;
          } else {
            ORIGINAL_URL_PRODUCT = item.properties[key];
          }
        }
        }
      });
      properties += '</ul>'
    }

    let itemUrlCustom = item.url;

    if(ORIGINAL_URL_PRODUCT != "") {
      itemUrlCustom = "/products/" + ORIGINAL_URL_PRODUCT;
    }
    
    const concatProductInfo = `
      <div class="CartItemWrapper">
        <div class="CartItem " data-line="${Number(index + 1)}">
          <div class="CartItem__ImageWrapper">
            <div class="">
              <img class="cart-item__image" src="${item.image}&width=200" width="100" height="100">
            </div>
          </div>
          <div class="CartItem__Info">
            <div class="CartItem_Info_top">
              <a href="${itemUrlCustom}" class="CartItem__Title Heading">
                ${item.title}
              </a>
               <div class="CartItem__properties"> ${properties}</div>
              <div class="CartItem__Meta Heading Text--subdued">
                <div class="CartItem__PriceList">
                  <div class="custom_option">
                    <span class="CartItem__Property--key">${custom_length}</span>
                  </div>                 
                </div>
              </div>
            </div>
            <div class="CartItem__Actions Heading Text--subdued" style="text-align: center">
              <div class="CartItem__Price_item">
                <b class="CartItem_price_item">${Shopify.formatMoney(item.line_price)}</b>      
                ${productitemprice > item.line_price ? `
                <b class="CartItem__Price Price" data-money-convertible="" data-SubPriceItem="${Number(index + 1)}"> ${Shopify.formatMoney(productitemprice)}</b>`
                : ``} 
              </div>
              <div class="CartItem__QuantitySelector">
                <div class="QuantitySelector">
                  <div class="mini_qtybox">
                    <span class="mini_btnqty qtyminus icon icon-minus" data-cartproductid="${item.properties['pid']}"></span>
                    <input
                      class="quantity-selector quantity-input QuantitySelector__CurrentQuantity"
                      type="text"
                      id="quantity"
                      name="quantity"
                      min="1"
                      maxlength="4"
                      pattern="\d{4}"
                      value="${item.quantity}"
                    >
                    <input
                      class="mini_cart_variant_id"
                      type="hidden"
                      value="${item.variant_id}"
                    >
                    <input
                      class="mini_cart_product_qty"
                      type="hidden"
                      value="${item.quantity}"
                    >
                    <span class="mini_btnqty qtyplus icon icon-plus" data-cartproductid="${item.properties['pid']}"></span>
                  </div>
                </div>
              </div>
              <div class="ajax-cart-item__remove ${defaults.removeFromCartNoDot}"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><g opacity="0.6"><path d="M5.83366 3.33333V1.66666H14.167V3.33333H18.3337V5H16.667V17.5C16.667 17.9602 16.2939 18.3333 15.8337 18.3333H4.16699C3.70676 18.3333 3.33366 17.9602 3.33366 17.5V5H1.66699V3.33333H5.83366ZM5.00033 5V16.6667H15.0003V5H5.00033ZM7.50033 7.5H9.16699V14.1667H7.50033V7.5ZM10.8337 7.5H12.5003V14.1667H10.8337V7.5Z" fill="black"/></g></svg></div>
            </div>
          </div>
        </div>
      </div>
    `;
    cartDrawerContent.innerHTML = cartDrawerContent.innerHTML + concatProductInfo;
    var cart_totalprice = cart.items_subtotal_price;
    var max_lengthcount = parseInt($('.shipping-progress').attr('data-maxlength'));    
    var BarLengthCount = parseInt(cart_totalprice * 100 / max_lengthcount);
    $(".shipping-progress-fill").css("width",BarLengthCount+"%");      
    
    });
    
    var shippingtotalprice = Shopify.formatMoney(cart.items_subtotal_price);
    var shippingTotalPriceFinal = parseFloat(shippingtotalprice.replace(/[$,]/g, ''));        
    var shippingProgressTest1 = parseFloat($(".shipping-mailstone-1").text().replace(/[$,]/g, '')); 
    var shippingProgressTest2 = parseFloat($(".shipping-mailstone-2").text().replace(/[$,]/g, ''));
    var shippingProgressTest3 = parseFloat($(".shipping-mailstone-3").text().replace(/[$,]/g, ''));
    var shippingProgresstext1 = $(".shipping-mailstone-text-1").text().trim();
    var shippingProgresstext2 = $(".shipping-mailstone-text-2").text().trim();
    var shippingProgresstext3 = $(".shipping-mailstone-text-3").text().trim();
    var shippingProgresstext;
    /*SE NEW*/
    var shippingProgressRewards;

    $('.Cart_ShippingNotice .Drawer__Data').find('.inner_span').remove();

    if (shippingTotalPriceFinal < shippingProgressTest1) {
      let seGoalCalculationPricing = parseFloat(shippingProgressTest1) - parseFloat(shippingTotalPriceFinal);
        shippingProgresstext = '';
        shippingProgressRewards = `<span class="inner_span">Spend $${seGoalCalculationPricing.toFixed(2)} more and get free USPS shipping!</span>`;
    } else if (shippingTotalPriceFinal < shippingProgressTest2) {
        let seGoalCalculationPricing = parseFloat(shippingProgressTest2) - parseFloat(shippingTotalPriceFinal);
        shippingProgresstext = shippingProgresstext2;
        shippingProgressRewards = `<span class="inner_span">Spend $${seGoalCalculationPricing.toFixed(2)} more and get free GROUND shipping!</span>`;
    } else if (shippingTotalPriceFinal < shippingProgressTest3) {
        let seGoalCalculationPricing = parseFloat(shippingProgressTest3) - parseFloat(shippingTotalPriceFinal);
        shippingProgresstext = shippingProgresstext3;
        shippingProgressRewards = `<span class="inner_span">Spend $${seGoalCalculationPricing.toFixed(2)} more and get free 2nd Day Air shipping!</span>`;
    } else {
        shippingProgresstext = shippingProgresstext3;
        shippingProgressRewards = `<span class="inner_span">Checkout now and get free 2nd Day Air shipping!</span>`;
    }

    if (shippingProgresstext !== '') {
        //var shippingProgressRewards = '<u class="test" style="text-decoration: unset;"> + ' + shippingProgresstext + '</u>';        
    }
    
    $('.Cart_ShippingNotice .Drawer__Data p').append(shippingProgressRewards);

    var totalpricereward = Shopify.formatMoney(cart.total_price);
    var discountPercentageNumber_total = parseFloat(totalpricereward.replace(/[$,]/g, ''));
    var discountedTotal = Math.abs((discountPercentageNumber_total - shippingTotalPriceFinal).toFixed(2));

    $('.reward_title_subtotle').text('$'+ discountedTotal.toFixed(2));    

  removeFromCart = document.querySelectorAll(defaults.removeFromCart);
  for (let i = 0; i < removeFromCart.length; i++) {
    removeFromCart[i].addEventListener('click', function () {
      const line = $(this).parents('.CartItemWrapper').find('.CartItem').attr("data-line");
      changeItem(line);
    });
  }
}


function openCartDrawer() {
  cartDrawer.classList.add('is-open');
}

function closeCartDrawer() {
  cartDrawer.classList.remove('is-open');
}

function clearCartDrawer() {
  cartDrawerContent.innerHTML = '';
}

function openCartOverlay() {
  cartOverlay.classList.add('is-open');
  htmlSelector.classList.add('is-locked');
}

function closeCartOverlay() {
  cartOverlay.classList.remove('is-open');
  htmlSelector.classList.remove('is-locked');
}

cartModalClose.addEventListener('click', function () {
  closeCartOverlay();
});

cartDrawerClose.addEventListener('click', function () {
  closeCartDrawer();
  closeCartOverlay();
});
// cart is empty stanje
cartOverlay.addEventListener('click', function () {
  closeCartDrawer();
  closeCartOverlay();
});

cartDrawerTrigger.addEventListener('click', function (event) {
  event.preventDefault();
  fetchCart();
  openCartDrawer();
  openCartOverlay();
});

document.addEventListener('DOMContentLoaded', function () {
  fetchCart();
});

function updateTotalPrice(cart) {
    var formattedPrice = Shopify.formatMoney(cart.items[0].final_line_price, '${{amount}}');
    $("#cus_total_price").text(formattedPrice);
}

// function updateTotalPrice_cartdrawer(cart) {
//   var formattedPrice = Shopify.formatMoney(cart.items[0].final_line_price, '${{amount}}');
//   $(".CartItem__Price").text(formattedPrice);
// }

$(document).on('change', '.quantity-input', function () {
  var qty = parseInt($(this).val());
  var pro_variation_id = parseInt($(this).parent('.mini_qtybox').find('.mini_cart_variant_id').val());  
  var line = $(this).closest('.CartItem').attr('data-line');
  jQuery.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: { quantity: qty, line: line },
    dataType: 'json',
    success: function () {
      fetchCart(); 
    }
  }); 
});


$(document).on('click', '.qtyplus, .qtyminus', function () {
  var qtyInput = $(this).parent('.mini_qtybox').find('.quantity-input');
  var qty = parseInt(qtyInput.val());
  var pro_variation_id = parseInt($(this).parent('.mini_qtybox').find('.mini_cart_variant_id').val());
  var line = $(this).closest('.CartItem').attr('data-line');
  var currentbtn_productid = $(this).attr('data-cartproductid'); 
  
  if ($(this).hasClass('qtyplus')) {
    qty++;
    changeQunatity(pro_variation_id, line, qty);
  } else {
    if (qty > 1) {
      qty--;
       changepropertyminusQunatity(pro_variation_id, line, qty);
    }
    if (qty > 0) {
      removeSigleQtyItem(line, qty);
    } else {
      changeItem(line);
    }
  }
  qty = (isNaN(qty)) ? 1 : qty;
  qtyInput.val(qty);

  $('#pieces-quantity[data-productqtyid="'+currentbtn_productid+'"]').val(qty);
  $('#pieces-quantity[data-productqtyid="'+currentbtn_productid+'"]').trigger('change');  
});

function changeQunatity(pro_variation_id, line, quantity) {
  $.getJSON('/cart.js', function(cart){ 
        var selected_cardproduct_no = line - 1;
        var cartproduct_line = cart.items[selected_cardproduct_no];
        const cartproduct_lineprice = cart.items[selected_cardproduct_no].price;
              var item_id = cartproduct_line.id;
            if(pro_variation_id == item_id){
              var all_properties = cartproduct_line.properties;
              all_properties.qty = quantity;
              $.ajax({
                url: '/cart/change.js',
                type: 'post',
                dataType: 'json',
                data: {
                  line: line,
                  quantity: quantity,
                  properties: all_properties
                },
                success: function (cart) {
                  $('#pieces-quantity').val(cart.items[0].quantity);   
                  updateTotalPrice(cart);
                  fetchCart();  
                },
                error: function (error) {
                  console.error('Error updating cart:', error);
                }
              });
            }else{
              $.ajax({
                type: 'POST',
                url: '/cart/change.js',
                data: 'quantity=' + quantity + '&line=' + line, 
                dataType: 'json',
                success: function (cart) {
                  fetchCart();                    
                },
              });
            }
    	});
  
}
function changepropertyminusQunatity(pro_variation_id, line, quantity) {   
      $.getJSON('/cart.js', function(cart){ 
        var selected_cardproduct_no = line - 1;
        var cartproduct_line = cart.items[selected_cardproduct_no];
              var item_id = cartproduct_line.id;
            if(pro_variation_id == item_id){
              var all_properties = cartproduct_line.properties;
              all_properties.qty = quantity;
              $.ajax({
                url: '/cart/change.js',
                type: 'post',
                dataType: 'json',
                data: {
                  line: line,
                  quantity: quantity,
                  properties: all_properties
                },
                success: function (cart) {
                  console.log('Cart updated successfully:', cart);                 
                  updateTotalPrice(cart)
                  fetchCart();
                },
                error: function (error) {
                  console.error('Error updating cart:', error);
                }
              });
            }else{
              $.ajax({
                type: 'POST',
                url: '/cart/change.js',
                data: 'quantity=' + quantity + '&line=' + line, 
                dataType: 'json',
                success: function (cart) { 
                   fetchCart();
                }
              });
            }
  });
}
function removeSigleQtyItem(line, quantity, qty) {
  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line, 
    dataType: 'json',
    success: function (cart) {
      fetchCart();      
    },
  });
}

function updateCartQuantity(line, quantity) {
  var newProperties = {
    qty: quantity
  };
  $.ajax({
    url: '/cart/update.js',
    type: 'post',
    dataType: 'json',
    data: 'quantity=' + quantity + '&line=' + line + '&properties=' + newProperties,
    success: function (cart) {   
      fetchCart();
    }
  });

$.ajax({
  url: '/cart/update.js',
  type: 'post',
  dataType: 'json',
  data: {
    line: line,
    properties: {
      qty: quantity
    }
  },
  success: function (cart) {
    // Cart updated successfully
    // You can fetch the updated cart or update your UI as needed    
    fetchCart();
  },
  error: function (error) {
    console.error('Error updating cart:', error);
  }
});
  
}

var freeshippingText = $('.freeshipping_direction').text();
$('.country_direction').text(freeshippingText);

var color1 = '#F44336';
var color2 = '#d8ac8f';
var color3 = '#d8ac8f';
$('.data-subtotal_price').on('DOMSubtreeModified', function () {

  var cartTotalPrice = $(this).html();
  var newValue = cartTotalPrice.replace('$', '');
  var iNum = newValue.toString();
  var cartNum1 = iNum.replace(",", "");
  var cartNum = parseInt(cartNum1);

  iNum = cartNum * 100;

  var threshold = $('.Cart_ShippingNotice').data('threshold');

  var threshold1 = 100;
  var threshold2 = 25000;
  var threshold3 = 25000;
  var threshold4 = 50000;
  var threshold5 = 75000;
  var threshold6 = 100000;
  var threshold7 = 150000;
  var threshold8 = 500000;
  var threshold9 = 1000000;
  var threshold10 = 1500000;

  // var threshold = 5000;
  //var freeshipBar = Math.round((iNum * 100)/threshold) ;
  //console.log(iNum);

  if (iNum >= threshold) {
    var freeshipBar = Math.round((iNum * 100) / threshold);
  }
  else if (iNum == threshold1) {
    var freeshipBar = Math.round((iNum * 100) / threshold);
  }
  else if (iNum <= threshold2) {
    var new_threshold = threshold2 - threshold1;
    var remaning = threshold2 - iNum;
    var total_diff = new_threshold - remaning;
    var freeshipBar = Math.round((total_diff / new_threshold) * 100);

  }
  else if (iNum <= threshold3) {
    // console.log('threshold3');
    var new_threshold = threshold3 - threshold2;
    var remaning = threshold3 - iNum;
    var total_diff = new_threshold - remaning;
    var freeshipBar = Math.round((total_diff / new_threshold) * 100);
  }
  else if (iNum <= threshold4) {
    // console.log('threshold4');
    var new_threshold = threshold4 - threshold3;
    var remaning = threshold4 - iNum;
    var total_diff = new_threshold - remaning;
    var freeshipBar = Math.round((total_diff / new_threshold) * 100);
  }
  else if (iNum <= threshold5) {
    // console.log('threshold5');
    var new_threshold = threshold5 - threshold4;
    var remaning = threshold5 - iNum;
    var total_diff = new_threshold - remaning;
    var freeshipBar = Math.round((total_diff / new_threshold) * 100);
  }
  else if (iNum <= threshold6) {
    // console.log('threshold6');
    var new_threshold = threshold6 - threshold5;
    var remaning = threshold6 - iNum;
    var total_diff = new_threshold - remaning;
    var freeshipBar = Math.round((total_diff / new_threshold) * 100);
  }
  else if (iNum <= threshold7) {
    // console.log('threshold7');
    var new_threshold = threshold7 - threshold6;
    var remaning = threshold7 - iNum;
    var total_diff = new_threshold - remaning;
    var freeshipBar = Math.round((total_diff / new_threshold) * 100);
  }
  else if (iNum <= threshold8) {
    // console.log('threshold8');
    var new_threshold = threshold8 - threshold7;
    var remaning = threshold8 - iNum;
    var total_diff = new_threshold - remaning;
    var freeshipBar = Math.round((total_diff / new_threshold) * 100);
  }
  else if (iNum <= threshold9) {
    // console.log('threshold9');
    var new_threshold = threshold9 - threshold8;
    var remaning = threshold9 - iNum;
    var total_diff = new_threshold - remaning;
    var freeshipBar = Math.round((total_diff / new_threshold) * 100);
  }
  else if (iNum <= threshold10) {
    // console.log('threshold10');
    var new_threshold = threshold10 - threshold9;
    var remaning = threshold10 - iNum;
    var total_diff = new_threshold - remaning;
    var freeshipBar = Math.round((total_diff / new_threshold) * 100);
  }
  else if (iNum < threshold) {
    var freeshipBar = Math.round((iNum * 100) / threshold);
  }
  if (freeshipBar >= 100) {
    freeshipBar = 100;
  }
  var color = color3;
  if (freeshipBar <= 30) {
    color = color1;
  }
  else if (freeshipBar <= 75) {
    color = color2;
  }
  else if (freeshipBar >= 75) {
    color = color3;
  }
  else if (freeshipBar == 100) {
    color = color3;
  }
  if (cartNum == 0) {
    $('.free_shipping_box').hide();
    $('.discount_offer_product_link').hide();
    $('.Cart_ShippingNotice .Drawer__Data').html($('.cart_deafult_shipping_msg').html());
    $('.reward').hide();
  }
  else {
    $('.free_shipping_box').show(); 

    if (threshold != undefined) {
      var progress = '<div class="progress_shipping" role="progressbar" aria-label="progressbar" style="height: 25px; margin-top: 0; margin-bottom: 0;background-color: #fff9;-webkit-box-shadow: inset 0 1px 2px rgba(0,0,0,.1);box-shadow: inset 0 1px 2px rgba(0,0,0,.1);">\
            <div class="progress-meter" style="position: relative;display: block;height: 100%;background-color: '+ color + ';text-align: center; line-height: 25px;color: #ffffff;width: ' + freeshipBar + '%; -webkit-animation: 2s linear 0s normal none infinite running progress-bar-stripes;animation: 2s linear 0s normal none infinite running progress-bar-stripes;transition: 0.9s linear; transition-property: width, background-color;">' + freeshipBar + '%</div></div>';
      $('.free_shipping_progress').html(progress);      
      if (iNum == threshold1) {   
        
    $('.reward').hide();
        $('.Cart_ShippingNotice .Drawer__Data').html($('.5default-shipping').html());
        $('.reward_message').html($('.5default-reward').html());        
      }
      else if (iNum <= threshold2) {
        var remain = threshold2 - iNum;
        var FinalPrice = Shopify.formatMoney(remain);

        $('.reward').hide();
        $('.5off-shipping span').html(FinalPrice);
        $('.Cart_ShippingNotice .Drawer__Data').html($('.5off-shipping').html());
        $('.reward_message').html($('.5off-reward').html());     

      }
      else if (iNum <= threshold3) {
        var remain = threshold3 - iNum;
        var FinalPrice = Shopify.formatMoney(remain);

        $('.reward').show();
        $('.5-dis-shipping span').html(FinalPrice);
        $('.Cart_ShippingNotice .Drawer__Data').html($('.5-dis-shipping').html());
        $('.reward_message').html($('.5-dis-reward').html());
      }
      else if (iNum <= threshold4) {
        var remain = threshold4 - iNum;
        var FinalPrice = Shopify.formatMoney(remain);

        // $('.Cart_ShippingNotice .Drawer__Data').html('<p>Congrats! You just received a 7% Discount + <u>Free USPS Shipping!</u> <br/> Spend '+FinalPrice+' more to receive a 8% Discount + Free <u>Expedited Shipping!</u></p>');
        $('.reward').show();
        $('.7-dis-shipping span').html(FinalPrice);
        $('.Cart_ShippingNotice .Drawer__Data').html($('.7-dis-shipping').html());
        $('.reward_message').html($('.7-dis-reward').html());

      }
      else if (iNum <= threshold5) {
        var remain = threshold5 - iNum;
        var FinalPrice = Shopify.formatMoney(remain);
        // $('.Cart_ShippingNotice .Drawer__Data').html('<p>Congrats! You just received a 8% Discount + Free <u>Expedited Shipping!</u> <br/> Spend '+FinalPrice+' more to receive a 9% Discount + Free <u>Expedited Shipping!</u></p>');
        $('.reward').show();
        // $('.reward_message').html('<p>8% Discount + Free Expedited Shipping</p>');
        $('.8-dis-shipping span').html(FinalPrice);
        $('.Cart_ShippingNotice .Drawer__Data').html($('.8-dis-shipping').html());
        $('.reward_message').html($('.8-dis-reward').html());   

      }
      else if (iNum <= threshold6) {
        var remain = threshold6 - iNum;
        var FinalPrice = Shopify.formatMoney(remain);
        // $('.Cart_ShippingNotice .Drawer__Data').html('<p>Congrats! You just received a 9% Discount + Free <u>Expedited Shipping!</u> <br/> Spend '+FinalPrice+' more to receive a 10% Discount + Free <u>2-Day Shipping</u> (East Coast only)!</p>');
        $('.reward').show();
        // $('.reward_message').html('<p>9% Discount + Free Expedited Shipping</p>');
        $('.9-dis-shipping span').html(FinalPrice);
        $('.Cart_ShippingNotice .Drawer__Data').html($('.9-dis-shipping').html());
        $('.reward_message').html($('.9-dis-reward').html());

      }
      else if (iNum <= threshold7) {
        var remain = threshold7 - iNum;
        // console.log(remain);
        var FinalPrice = Shopify.formatMoney(remain);
        // $('.Cart_ShippingNotice .Drawer__Data').html('<p>Congrats! You just received a 10% Discount + Free <u>2-Day Shipping</u> (East Coast only)! <br/> Spend '+FinalPrice+' more to receive an 11% Discount + Free <u>2-Day Shipping</u> (East Coast & Central)!</p>');
        $('.reward').show();
        // $('.reward_message').html('<p>10% Discount + Free 2-Day Shipping</p>');
        $('.10-dis-shipping span').html(FinalPrice);
        $('.Cart_ShippingNotice .Drawer__Data').html($('.10-dis-shipping').html());
        $('.reward_message').html($('.10-dis-reward').html());
      }
      else if (iNum <= threshold8) {
        var remain = threshold8 - iNum;
        // console.log(remain);
        var FinalPrice = Shopify.formatMoney(remain);
        // $('.Cart_ShippingNotice .Drawer__Data').html('<p>Congrats! You just received a 11% Discount + Free <u>2-Day Shipping</u> (East Coast & Central)! <br/> Spend '+FinalPrice+' more to receive a 12% Discount + Free <u>2-Day Shipping</u> (All US)!</p>');
        $('.reward').show();
        // $('.reward_message').html('<p>11% Discount + Free 2-Day Shipping</p>');
        $('.11-dis-shipping span').html(FinalPrice);
        $('.Cart_ShippingNotice .Drawer__Data').html($('.11-dis-shipping').html());
        $('.reward_message').html($('.11-dis-reward').html());

      }
      else if (iNum <= threshold9) {
        var remain = threshold9 - iNum;
        // console.log(remain);
        var FinalPrice = Shopify.formatMoney(remain);
        // $('.Cart_ShippingNotice .Drawer__Data').html('<p>Congrats! You just received a 11% Discount + Free <u>2-Day Shipping</u> (East Coast & Central)! <br/> Spend '+FinalPrice+' more to receive a 12% Discount + Free <u>2-Day Shipping</u> (All US)!</p>');
        $('.reward').show();
        // $('.reward_message').html('<p>11% Discount + Free 2-Day Shipping</p>');
        $('.12-dis-shipping span').html(FinalPrice);
        $('.Cart_ShippingNotice .Drawer__Data').html($('.12-dis-shipping').html());
        $('.reward_message').html($('.12-dis-reward').html());
      }
      else if (iNum <= threshold10) {
        var remain = threshold10 - iNum;
        // console.log(remain);
        var FinalPrice = Shopify.formatMoney(remain);
        // $('.Cart_ShippingNotice .Drawer__Data').html('<p>Congrats! You just received a 11% Discount + Free <u>2-Day Shipping</u> (East Coast & Central)! <br/> Spend '+FinalPrice+' more to receive a 12% Discount + Free <u>2-Day Shipping</u> (All US)!</p>');
        $('.reward').show();
        // $('.reward_message').html('<p>11% Discount + Free 2-Day Shipping</p>');
        $('.13-dis-shipping span').html(FinalPrice);
        $('.Cart_ShippingNotice .Drawer__Data').html($('.13-dis-shipping').html());
        $('.reward_message').html($('.13-dis-reward').html());
      }
      else if (iNum >= threshold) {
        // $('.Cart_ShippingNotice .Drawer__Data').html('<p>Congrats! You just received a 12% Discount + Free <u>2-Day Shipping</u>(All US)!</p> <p> If purchasing $10,000+, please contact us! Additional discounts could be available! </p>');
        $('.reward').show();
        // $('.reward_message').html('<p>12% Discount + 2-Day Shipping</p>');
        $('.above-10k-shipping span').html(FinalPrice);
        $('.Cart_ShippingNotice .Drawer__Data').html($('.above-10k-shipping').html());
        $('.reward_message').html($('.above-10k-reward').html());
      }
      else if (iNum < threshold) {
        var remain = threshold - iNum;
        var FinalPrice = Shopify.formatMoney(remain);
        $('.Cart_ShippingNotice .Drawer__Data').html('<p class="shake_animation">Spend ' + FinalPrice + ' more and 12% Discount + Free <u>2-Day Shipping</u> (All US)!</p>');
        $('.reward').show();
        $('.reward_message').html('<p>12% Discount + Free 2-Day Shipping</p>');        
      }
    }    
  }
});


$(function () {
  $('.ajax-cart-qu-add').click(function () {
    var selectedInput = $(this).prev('input');
    if (selectedInput.val() < 10) {
      selectedInput[0].stepUp(1);
    }
  });
  $('.ajax-cart-qu-sub').click(function () {
    var selectedInput = $(this).next('input');
    if (selectedInput.val() > 0) {
      selectedInput[0].stepDown(1);
    }
  });

  setInterval(function () {
    $(".cart-shake").hasClass("shake") ? $(".cart-shake").removeClass("shake") : $(".cart-shake").addClass("shake");
  }, 2.2e3);

  $(".cart-count-mobile").on('click', function (e) {
    // e.preventDefault();
    // $(document).find(".js-ajax-cart-drawer").addClass('is-open');
    e.preventDefault();
    fetchCart();
    openCartDrawer();
    openCartOverlay();
  });

});
